import { CognitoUserPool } from 'amazon-cognito-identity-js';

export const cognitoConfig = {
  region: process.env.REACT_APP_AWS_REGION!,
  userPoolId: process.env.REACT_APP_USER_POOL_ID!,
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN!,
  redirectUri: process.env.REACT_APP_REDIRECT_URI!,
  logoutUri: process.env.REACT_APP_LOGOUT_URI!,
  apiEndpoint: process.env.REACT_APP_API_BASE_URL!,
} as const;

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_AWS_REGION',
  'REACT_APP_USER_POOL_ID',
  'REACT_APP_USER_POOL_CLIENT_ID',
  'REACT_APP_COGNITO_DOMAIN',
] as const;

requiredEnvVars.forEach((varName) => {
  if (!process.env[varName]) {
    throw new Error(`Missing required environment variable: ${varName}`);
  }
});

export const userPool = new CognitoUserPool({
  UserPoolId: cognitoConfig.userPoolId,
  ClientId: cognitoConfig.userPoolClientId,
});

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'cmh_access_token',
  ID_TOKEN: 'cmh_id_token',
  REFRESH_TOKEN: 'cmh_refresh_token',
  USER_DATA: 'cmh_user_data',
  AUTH_STATE: 'cmh_auth_state',
} as const;